import React, { useState, useEffect } from 'react';
import styles from './CookieNotification.module.scss';
import Cookie from '../Icons/Cookie';

export const CONSENT_KEY = 'gdpr_consent';
export const CONSENT_VERSION = '1';

export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => {
  const consent = getStoredConsent();
  return consent?.analytics === true;
};

const CookieNotification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getStoredConsent();
    if (!consent || consent.version !== CONSENT_VERSION) {
      setIsVisible(true);
    }
  }, []);

  const saveConsent = (analytics) => {
    const consent = {
      version: CONSENT_VERSION,
      analytics,
      necessary: true,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    // Dispatch event so other parts of the app can react (e.g. load GA)
    window.dispatchEvent(
      new CustomEvent('gdpr-consent-updated', { detail: consent })
    );
    setIsVisible(false);
  };

  const handleAcceptAll = () => saveConsent(true);
  const handleDecline = () => saveConsent(false);

  if (!isVisible) return null;

  return (
    <div
      className={styles.cookieNotification}
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className={styles.cookieNotificationContent}>
        <h3 className={styles.cookieHeader}>
          <Cookie /> We use cookies
        </h3>
        <p className={styles.cookieText}>
          We use necessary cookies to keep the app working and, with your
          consent, analytics cookies (Google Analytics) to understand how people
          use Good Song Club. Your data may be processed in the US.{' '}
          <a href="/privacy" className={styles.privacyLink}>
            Privacy Policy
          </a>
        </p>
      </div>
      <div className={styles.buttonGroup}>
        <button onClick={handleDecline} className={styles.declineButton}>
          Necessary only
        </button>
        <button onClick={handleAcceptAll} className={styles.acceptButton}>
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieNotification;
